import routes from './routes'
import store from './store'

export default {
    name: 'm-permissions',
    store: store,
    routes: routes
}